/**
 * Footer Newsletter JS
 * To set Ajax to register email to the external system
 * And "visual effect"
 */
jQuery(document).ready(function(){

    jQuery(".loading").hide();

    jQuery("#newsletterFooterForm").submit(function () {

        // Check if email is OK
        if (!IsEmail(jQuery('#email').val())) {
            setNewsletterEmailTextInError(jQuery('#email')) ;
            return false;
        }

        jQuery(".loading").show();
        var motcle = jQuery("#email").val();
        var DATA = 'email=' + motcle;
        jQuery.ajax({
            type: "POST",
            url: jQuery("#newsletterFooterForm").data("urlPost"),
            data: DATA,
            cache: false,
            success: function () {
                jQuery(".loading").hide();
                setNewsletterEmailTextInSuccess(jQuery('#email'));
            },
            error: function () {
                jQuery(".loading").hide();
                setNewsletterEmailTextInError(jQuery('#email')) ;
            }
        });
        return false;
    });
});
